import {
    formHelperTextClasses,
    inputBaseClasses,
    outlinedInputClasses,
    Select as MuiSelect,
    selectClasses,
    styled,
    TextField as MuiTextField,
} from '@mui/material';

import { theme } from '../../../../../../theme';
import { Checkbox } from '../../../../../form/Checkbox/Checkbox';

export const StyledMuiTextField = styled(MuiTextField, {
    shouldForwardProp: (propName: string) => propName !== 'modified',
})<{ modified?: boolean }>`
    width: 100px;
    ${({ error }) =>
        error
            ? {
                  marginTop: '14px',
              }
            : ''}
    & > .${inputBaseClasses.root} {
        min-height: 50px;
        border-radius: ${({ theme }) => theme.shape.borderRadiusLarge}px;
        ${({ disabled }) =>
            disabled
                ? {
                      backgroundColor: 'rgba(255, 255, 255, 0.12)',
                  }
                : {
                      backgroundColor: theme.palette.secondary.light,
                  }}

        ${({ modified }) =>
            modified
                ? {
                      borderColor: theme.palette.warning.main,
                      borderStyle: 'solid',
                      borderWidth: '0.4px',
                  }
                : ''}
        margin: 0;
        padding: 0;

        &:before,
        &:after {
            content: none;
        }

        input,
        textarea {
            padding: 15px;
            color: ${({ theme }) => theme.palette.primary.contrastText};
            border-radius: ${({ theme }) => theme.shape.borderRadiusLarge}px;
        }
    }

    & .${formHelperTextClasses.root} {
        height: 10px;
        margin: 5px 0 0;
        text-align: center;
    }
`;
export const StyledCheckbox = styled(Checkbox, {
    shouldForwardProp: (propName: string) => propName !== 'modified',
})<{ modified?: boolean }>`
    ${({ modified }) =>
        modified
            ? {
                  borderColor: theme.palette.warning.main,
                  borderStyle: 'solid',
                  borderWidth: '0.4px',
              }
            : ''}
`;

export const StyledSelect = styled(MuiSelect, {
    shouldForwardProp: (propName: string) => propName !== 'modified',
})<{ modified?: boolean }>`
    border-radius: 25px;
    min-width: 80px;
    color: white;
    ${({ modified }) =>
        modified
            ? {
                  borderColor: theme.palette.warning.main,
                  borderStyle: 'solid',
                  borderWidth: '0.4px',
              }
            : ''}
    & .${inputBaseClasses.root} {
        margin-top: 0;
        flex-shrink: 0;
        height: 50px;
        width: 100%;
        border-radius: 25px;
        color: ${({ theme }) => theme.palette.primary.contrastText};

        & > .${selectClasses.select} {
            padding: 10px 40px 10px 15px !important;
            color: currentColor;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 18px;
            box-sizing: border-box;
        }

        & > .${selectClasses.icon} {
            color: inherit;
            margin-right: 10px;
            pointer-events: none;
        }
        &.${outlinedInputClasses.root} > .${outlinedInputClasses.notchedOutline} {
            border-color: ${({ theme }) => theme.palette.blue.lightest};
            border-width: 1px;
        }
    }
`;
